// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/goal.css
// module id = 248
// module chunks = 0